import { useQuery } from '@tanstack/react-query';

import { $api } from 'modules/global';

import { profileConst } from '..';

export const useAvatar = (open?: boolean) => {
  const { data: avatars, ...args } = useQuery<string[]>({
    queryKey: [profileConst.queryKeys.USE_AVATAR],
    queryFn: async () => {
      const response = await $api.get('/avatar-images');

      return response.data;
    },
    enabled: !!open
  });

  return { avatars, ...args };
};
